export default __webpack_public_path__ + "static/media/spell6.1c65c609.jpg";